import { render, staticRenderFns } from "./PersonalDescriptionPanel.vue?vue&type=template&id=0bd7c639&scoped=true"
import script from "./PersonalDescriptionPanel.vue?vue&type=script&lang=js"
export * from "./PersonalDescriptionPanel.vue?vue&type=script&lang=js"
import style0 from "./PersonalDescriptionPanel.vue?vue&type=style&index=0&id=0bd7c639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7c639",
  null
  
)

export default component.exports